setTimeout(function() {
        if (Global && Global.isPro) {
            console.log("2026年1月26日 15:57:51")
        }
    }, 1000)